<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="adc" epub:type="frontmatter">
<header>
<h1 class="FMH" id="adc"><span aria-label=" Page iii. " epub:type="pagebreak" id="pg_iii" role="doc-pagebreak"><samp><b>ALSO BY KEN KALFUS</b></samp></span></h1>
</header>
<p class="TC"><i>Coup de Foudre: A Novella and Stories</i></p>
<p class="TC"><i>Equilateral: A Novel</i></p>
<p class="TC"><i>A Disorder Peculiar to the Country: A Novel</i></p>
<p class="TC"><i>The Commissariat of Enlightenment: A Novel</i></p>
<p class="TC"><i>Pu-239 and Other Russian Fantasies:</i></p>
<p class="TC"><i>A Novella and Stories</i></p>
<p class="TC"><i>Thirst: Stories</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// adcard.vue?13e6914d